import React, { useState } from 'react';
import { Mail, Wand2, Settings as SettingsIcon, History, FileText } from 'lucide-react';
import NewsletterCreateTab from './NewsletterCreateTab';
import NewsletterImportTab from './NewsletterImportTab';
import NewsletterHistoryTab from './NewsletterHistoryTab';
import NewsletterTemplatesTab from './NewsletterTemplatesTab';

export default function NewsletterPage() {
  const [tab, setTab] = useState('create');

  return (
    <div className="page-scroll" data-testid="newsletter-page">
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Mail size={22} style={{ color: 'var(--accent)' }} />
          <h1 className="page-title" style={{ margin: 0 }}>Nyhetsbrev</h1>
        </div>
        <p className="page-subtitle">
          Skapa kampanjtexter på alla marknader, lär av historisk Mailchimp-prestanda.
        </p>
      </div>

      <div className="tab-switcher" style={{ marginBottom: 24 }}>
        <button
          data-testid="nl-tab-create"
          className={`tab-btn${tab === 'create' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('create')}
        >
          <Wand2 size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Skapa nyhetsbrev
        </button>
        <button
          data-testid="nl-tab-templates"
          className={`tab-btn${tab === 'templates' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('templates')}
        >
          <FileText size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Mallar
        </button>
        <button
          data-testid="nl-tab-settings"
          className={`tab-btn${tab === 'settings' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('settings')}
        >
          <SettingsIcon size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Inställningar
        </button>
        <button
          data-testid="nl-tab-history"
          className={`tab-btn${tab === 'history' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('history')}
        >
          <History size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Historik
        </button>
      </div>

      {tab === 'create'    && <NewsletterCreateTab />}
      {tab === 'templates' && <NewsletterTemplatesTab />}
      {tab === 'settings'  && <NewsletterImportTab />}
      {tab === 'history'   && <NewsletterHistoryTab />}
    </div>
  );
}
